import React from 'react'

import { ProgressStatus, TrendBars, TrendCard, TrendHeader } from '../styles'

import type { ProgressTrendPoint } from './types'

interface ProgressTrendProps {
  points: ProgressTrendPoint[]
}

const ProgressTrend = ({ points }: ProgressTrendProps) => {
  const maximum = Math.max(...points.map((point) => point.value), 1)

  return (
    <TrendCard>
      <TrendHeader>
        <div>
          <strong>Evolución del período</strong>
          <span>Actividad, prácticas y desafíos</span>
        </div>
        <small>Ah-plausos generados</small>
      </TrendHeader>
      {points.length === 0 ? (
        <ProgressStatus>
          No hay datos suficientes para mostrar la evolución de este período.
        </ProgressStatus>
      ) : (
        <TrendBars aria-label="Evolución de Ah-plausos del período">
          {points.map((point) => {
            const height = 8 + (point.value / maximum) * 72

            return (
              <div
                key={point.label}
                role="img"
                data-empty={point.value === 0}
                aria-label={`${point.label}: ${point.value} Ah-plausos`}
              >
                {point.value > 0 && <b aria-hidden="true">{point.value}</b>}
                <span aria-hidden="true" style={{ height: `${height}px` }} />
                <small>{point.label}</small>
              </div>
            )
          })}
        </TrendBars>
      )}
    </TrendCard>
  )
}

export default ProgressTrend
